import React from 'react';

import {gt} from 'app/utils/i18n';

interface ButtonStructureProps {
  onClick: () => unknown;
  children: React.ReactNode;
}

export function ButtonStructure({onClick, children}: ButtonStructureProps) {
  return (
    <button className="btn btn-link btn-sm" onClick={onClick} type="button">
      <i className="fa fa-plus mr-1" />
      {children}
    </button>
  );
}

interface Props {
  onClick: () => unknown;
}

export function ShowAssignUsersButton({onClick}: Props) {
  return (
    <ButtonStructure onClick={onClick}>
      {gt('assign to teammate')}
    </ButtonStructure>
  );
}

export function ShowAssignTeamsButton({onClick}: Props) {
  return (
    <ButtonStructure onClick={onClick}>{gt('assign to team')}</ButtonStructure>
  );
}

export function ShowAssignRolesButton({onClick}: Props) {
  return (
    <ButtonStructure onClick={onClick}>{gt('assign to role')}</ButtonStructure>
  );
}
